import { motion, AnimatePresence } from "framer-motion";

const formatRupiah = (number) => {
  return number ? Number(number).toLocaleString("id-ID") : 0;
};

const DesktopShippingOptionModal = ({
  open,
  onClose,
  formatShippingEstimationDisplay,
  tempSelectedShipping,
  setTempSelectedShipping,
  buildShippingFieldsFromOption,
  shippingGroups,
  selectedShippingKey,
  getOptionKey,
  handleConfirmShipping,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="hidden md:block fixed inset-0 bg-black/50 z-[9998]"
            onClick={onClose}
          />

          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.98 }}
            transition={{ duration: 0.18 }}
            className="hidden md:flex fixed inset-0 z-[9999] items-center justify-center p-6"
          >
            <div className="w-full max-w-2xl bg-white rounded-3xl border border-slate-200 shadow-2xl overflow-hidden">
              <div className="px-6 py-4 border-b border-slate-200">
                <h2 className="text-xl font-semibold text-slate-900">
                  Opsi Pengiriman
                </h2>
              </div>

              <div className="max-h-[60vh] overflow-y-auto p-5">
                {shippingGroups.length === 0 ? (
                  <p className="text-gray-400 text-center py-8">
                    Tidak ada opsi pengiriman tersedia
                  </p>
                ) : (
                  shippingGroups.map((group) => (
                    <div key={group.key} className="mb-4">
                      <h2 className="font-semibold text-slate-600 text-sm mb-2 uppercase tracking-wide">
                        {group.label}
                      </h2>
                      <div className="flex flex-col gap-2">
                        {group.options.map((option, idx) => {
                          const optionKey = getOptionKey(option, group.key);
                          const estimationLine = formatShippingEstimationDisplay(
                            option.estimation ?? option.etd ?? "",
                          );

                          const currentKey = tempSelectedShipping
                            ? getOptionKey(
                                {
                                  code: tempSelectedShipping.shipment_code,
                                  service_type:
                                    tempSelectedShipping.shipping_service_type,
                                },
                                tempSelectedShipping.shipping_group_code,
                              )
                            : selectedShippingKey;

                          const isSelected = optionKey === currentKey;

                          return (
                            <div
                              key={idx}
                              onClick={() =>
                                setTempSelectedShipping(
                                  buildShippingFieldsFromOption(
                                    option,
                                    group.key,
                                  ),
                                )
                              }
                              className={`w-full rounded-xl border flex items-center justify-between px-3 py-3 cursor-pointer ${
                                isSelected
                                  ? "border-secondary bg-secondaryActive"
                                  : "border-slate-300 bg-slate-100 hover:bg-slate-50"
                              }`}
                            >
                              <div className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  readOnly
                                  checked={isSelected}
                                  className="w-5 h-5 text-secondary focus:ring-secondary"
                                />
                                <div className="flex flex-col">
                                  <p className="font-semibold text-slate-700 text-md">
                                    {group.key === "instant"
                                      ? option.name
                                      : option.service_name || option.name}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    {estimationLine === "-"
                                      ? "Estimasi -"
                                      : `Estimasi ${estimationLine}`}
                                  </p>
                                </div>
                              </div>
                              <p className="font-semibold text-slate-700 text-md flex-shrink-0 tabular-nums">
                                Rp{formatRupiah(option.price)}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div className="px-6 py-4 border-t border-slate-200 bg-white flex items-center justify-end gap-3">
                <button
                  onClick={onClose}
                  className="h-11 px-4 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-50"
                >
                  Batal
                </button>
                <button
                  onClick={handleConfirmShipping}
                  disabled={!tempSelectedShipping && !selectedShippingKey}
                  className="h-11 px-5 rounded-xl border border-secondary bg-secondary text-white font-medium hover:bg-secondaryHover disabled:bg-slate-300 disabled:border-slate-300 disabled:cursor-default"
                >
                  Konfirmasi
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DesktopShippingOptionModal;